import WorkingCache from "csi/state/WorkingCache";
import { C8Node, cnl, ICache } from "csi/typings";
import { ReactionStore } from "csi/utility/mobxUtility";
import { action, makeObservable, observable } from "mobx";

export default class PageStore extends ReactionStore {
	@observable private readonly _pageNodeUrl: cnl;

	/** cache */
	readonly cache: ICache;

	/** the current node, fetch it from cache so that we always get the out-to-date version */
	get pageNode(): C8Node {
		const { cache, _pageNodeUrl } = this;
		return cache.get(_pageNodeUrl);
	}

	/** Extension point for creating store */
	@action onPageStoreCreate(): void { }

	/** Extension point for destroying store */
	@action onPageStoreDestroy(): void { }

	constructor(pageNode: C8Node, cache: ICache = new WorkingCache()) {
		super();
		makeObservable(this);
		cache.add(pageNode);
		this._pageNodeUrl = pageNode.$URL;
		this.cache = cache;
	}
}